import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './style.css'

class AppTitle extends Component {

  static propTypes = {
    appName: PropTypes.string.isRequired
  }

  render() {
    const { appName } = this.props
    return (
      <div className="app-title">
        <span>{appName}</span>
      </div>
    )
  }
}

export default AppTitle
